import { Injectable } from '@angular/core';

import { AppTranslationService } from './app-translation.service';
import { LocalStoreManager } from './local-store-manager.service';
import { Utilities } from './utilities';

type UserConfiguration = {
  language: string,
  theme: string,
};

@Injectable()
export class ConfigurationService {

  public apiUrl = Utilities.apiUrl();

  constructor(private localStorage: LocalStoreManager, private translationService: AppTranslationService) {
    this.loadLocalChanges();
  }

  private loadLocalChanges() {

  }
}
